// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../adm-saas/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-text.card-text[data-v-721ec376]{position:relative;padding:28px!important}.logo[data-v-721ec376]{max-width:298px;height:60px;background-repeat:no-repeat;background-size:contain;margin:16px 0}.description[data-v-721ec376]{font-size:19px;font-weight:400;line-height:1.16;text-align:left;color:#777;margin-bottom:35px}.close-icon[data-v-721ec376]{position:absolute;top:0;right:0;color:#474647}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
